export default __webpack_public_path__ + "static/media/MOH.d9778271.svg";